export class MessageBusResponse
{
    public IsSuccess: boolean;
    public ErrorMessage: string;
    public ErrorCode: number;
    public Result: any;
}
